export const ANIMATION_DURATION = 250;
export const HEADER = 60;
export const FOOTER = 65;
